import { call, put, retry } from 'redux-saga/effects';

import { Creators as BeneficiarioActions } from '../ducks/beneficiario';

import { BeneficiariosAPI, listasAPI } from '../../services/api';

export function* postDataBeneficiriesNestle(action) {
  const { params } = action.payload;

  try {
    const response = yield call(listasAPI.post, `/data-nestle`, params);
    const isSuccess = response.status === 200 || false;

    yield put(
      BeneficiarioActions.postDataBeneficiariesNestleSuccess(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(BeneficiarioActions.postDataBeneficiariesNestleError(error));
  }
}

export function* getDocumentosStatus(action) {
  const { params } = action.payload;

  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(
      2,
      2000,
      BeneficiariosAPI.get,
      `/documento-status`,
      { params: queryString }
    );

    const isSuccess = response.status === 200 || false;

    yield put(
      BeneficiarioActions.getDocumentosStatusSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(BeneficiarioActions.getDocumentosStatusError(error));
  }
}

export function* getDocumentoDetalhe(action) {
  const { params, idBeneficiario } = action.payload;

  const queryString = {
    ...params,
  };

  try {
    const response = yield retry(
      2,
      2000,
      BeneficiariosAPI.get,
      `/${idBeneficiario}/documento-detalhe`,
      { params: queryString }
    );

    const isSuccess = response.status === 200 || false;

    yield put(
      BeneficiarioActions.getDocumentoDetalheSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(BeneficiarioActions.getDocumentoDetalheError(error));
  }
}

export function* patchDocumentoConferencia(action) {
  const { params } = action.payload;

  try {
    const response = yield retry(
      2,
      2000,
      BeneficiariosAPI.patch,
      `/documento-conferencia`,
      {
        ...params,
      }
    );

    const isSuccess = response.status === 204 || false;

    yield put(
      BeneficiarioActions.patchDocumentoConferenciaSuccess(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(BeneficiarioActions.patchDocumentoConferenciaError(error));
  }
}
